import { STANDORT_BY_ID } from '@/domain/dienstplan/shared/hooks/useStandort/queries';
import { Standort } from '@/domain/dienstplan/shared/types/Standort';
import { useSuspenseQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

export function useStandort(standortId: string): Standort {
  const result = useSuspenseQuery(STANDORT_BY_ID, {
    variables: {
      standortId,
    },
    fetchPolicy: 'no-cache',
  });

  if (result.error) {
    Sentry.captureException(result.error);
  }

  return new Standort({
    tageswechsel: result.data.dienstplan_findStandortById.tageswechsel,
  });
}
